"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasNextPage = hasNextPage;

// ---- For Offset based pagination
function hasNextPage(pagination) {
  return pagination.to < pagination.fullCount - 1;
}